import React, { useState } from "react";
import { Flex, Text, Image, useMediaQuery } from "@chakra-ui/react";
import ResumeDownload from "./ResumeLoad";
import ResumeDownloadBig from "./ResumeLoadBig";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";

const HomePage = () => {
  const [isMobile] = useMediaQuery("(max-width: 1000px)");
  const [isMobileAbout] = useMediaQuery("(max-width: 750px)");

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const [formValues, setFormValues] = useState({
    name: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Configure the EmailJS service
    emailjs.init("w3hZfkHFQKw4kyifr");

    // Prepare the email template parameters
    const templateParams = {
      from_name: formValues.name,
      email: "vikassingh.vs242@gmail.com",
      subject: formValues.subject,
      message: formValues.message,
    };

    // Send the email using EmailJS
    emailjs
      .send("service_k5avv85", "template_646xip8", templateParams)
      .then((response) => {
        // Reset the form after successful submission
        setFormValues({
          name: "",
          subject: "",
          message: "",
        });
        return toast("Email sent successfully", {
          autoClose: 3000,
        });
      })
      .catch((error) => {
        return toast("Email sending failed:", error); // Handle the error here
      });
  };

  return (
    <>
      <ToastContainer />
      <Flex
        className="navbar navbar-expand-lg navbar-dark ftco_navbar ftco-navbar-light site-navbar-target position-fixed"
        id="ftco-navbar"
        style={{ top: 0, zIndex: 999 }}
      >
        <div className="container">
          <a className="navbar-brand">Portfolio</a>
          <button
            className={`navbar-toggler js-fh5co-nav-toggle fh5co-nav-toggle ${
              menuOpen ? "active" : ""
            }`}
            type="button"
            onClick={toggleMenu}
          >
            <span className="oi oi-menu"></span> Menu
          </button>

          <div
            className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
            id="ftco-nav"
          >
            <ul
              className={`navbar-nav nav ml-auto ${menuOpen ? "fade-in" : ""}`}
            >
              <li className="nav-item">
                <a
                  href="#home-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#about-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>About</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#resume-section"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#about-section").scrollIntoView({
                      behavior: "smooth",
                    });
                    closeMenu();
                  }}
                >
                  <span>Resume</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#services-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>Services</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#skills-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>Skills</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#projects-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>Projects</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#blog-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>My Blog</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#contact-section"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  <span>Contact</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        position={isMobile ? "relative" : "static"}
        gridGap="300px"
      >
        {isMobile && (
          <Image
            src="./images/profile.png"
            position="absolute"
            zIndex="-1"
            opacity={0.5}
            ml="48"
          />
        )}
        <Flex>
          {isMobile ? (
            <Flex
              direction="column"
              mt="120px"
              className="text"
              justifyContent="center"
              ml="10"
            >
              <span className="hello-text">Hello!</span>
              <h1 className="name-heading">
                I'm <span>Vikas Singh</span>
              </h1>
              <h2 className="role-heading mb-4">A Full Stack Developer</h2>
              <p>
                <Flex gap="8">
                  <a href=" " className="btn btn-primary py-3 px-4">
                    Hire me
                  </a>
                  <a
                    href=" "
                    className="btn btn-white btn-outline-white py-3 px-4"
                  >
                    My works
                  </a>
                </Flex>
              </p>
            </Flex>
          ) : (
            <div className="text">
              <span className="hello-text">Hello!</span>
              <h1 className="name-heading">
                I'm <span>Vikas Singh</span>
              </h1>
              <h2 className="role-heading mb-4">A Full Stack Developer</h2>
              <p>
                <Flex gap="8">
                  <a href=" " className="btn btn-primary py-3 px-4">
                    Hire me
                  </a>
                  <a
                    href=" "
                    className="btn btn-white btn-outline-white py-3 px-4"
                  >
                    My works
                  </a>
                </Flex>
              </p>
            </div>
          )}
        </Flex>
        {!isMobile && (
          <Flex alignItems="center">
            <Image src="./images/profile.png" />
          </Flex>
        )}
      </Flex>
      {/* about us section ------------->>>>> */}
      <Flex
        alignItems="center"
        justifyContent="center"
        gap="150px"
        mt={isMobile ? "150px" : "0"}
        width="90%"
        mx={isMobile ? "50px" : "0"}
      >
        {!isMobileAbout && (
          <Flex alignItems="center" justifyContent="center">
            <Image h="600px" src="./images/profile.png" />
          </Flex>
        )}

        <Flex id="about-section" direction="column" justifyContent="center">
          <h1 id="about-heading">About Me</h1>
          <ul className="about-info mt-4 px-md-0 px-2">
            <li className="d-flex">
              <span className="about-span1">Name:</span>
              <span className="about-span2">Vikas Singh</span>
            </li>
            <li className="d-flex">
              <span className="about-span1">Date of birth:</span>
              <span className="about-span2">December 31, 2000</span>
            </li>
            <li className="d-flex">
              <span className="about-span1">Address:</span>
              <span className="about-span2">Ajmer Road Jaipur</span>
            </li>
            <li className="d-flex">
              <span className="about-span1">Zip code:</span> <span>302021</span>
            </li>
            <li className="d-flex">
              <span className="about-span1">Email:</span>
              <span className="about-span2">vikassingh.vs242@gmail.com</span>
            </li>
            <li className="d-flex">
              <span className="about-span1">Phone: </span>
              <span className="about-span2">+91-7014888168</span>
            </li>
          </ul>
          <div className="counter-wrap d-flex mt-md-3">
            <div className="text">
              <Flex direction="column">
                <p className="mb-4">
                  <Flex gap="6">
                    <span className="number" data-number="120">
                      120
                    </span>
                    <span>Project complete</span>
                  </Flex>
                </p>
                <p>
                  <ResumeDownload />
                </p>
              </Flex>
            </div>
          </div>
        </Flex>
      </Flex>
      {/* experience and qualifications section     */}
      <Flex mt="10">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-md-10 heading-section text-center">
              <h1 className="big big-2">Experience</h1>
              <h2 className="mb-4">Experience And Qualification</h2>
              <p>
                A small river named Duden flows by their place and supplies it
                with the necessary regelialia. It is a paradisematic country, in
                which roasted parts of sentences fly into your mouth.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="resume-wrap ">
                <span className="date">2018-2022</span>
                <h2>Bachleor's Degree in Computer Science</h2>
                <span className="position">
                  Rajasthan Insitute Of Engineering & Technology
                </span>
                <p className="mt-4">
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia. It is a paradisematic country,
                  in which roasted parts of sentences fly into your mouth.
                </p>
              </div>
              <div className="resume-wrap ">
                <span className="date">August-2022-December-2022</span>
                <h2>Full Stack Developer</h2>
                <span className="position">Wisflux Tech Labs</span>
                <p className="mt-4">
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia. It is a paradisematic country,
                  in which roasted parts of sentences fly into your mouth.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="resume-wrap ">
                <span className="date">December 2022 - preset</span>
                <h2>Full Stack Developer</h2>
                <span className="position">Strivemindz Pvt Ltd</span>
                <p className="mt-4">
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia. It is a paradisematic country,
                  in which roasted parts of sentences fly into your mouth.
                </p>
              </div>
              <div className="resume-wrap">
                <span className="date">March 2022 - August 2022</span>
                <h2>Web Developer</h2>
                <span className="position">Wedigtech Jaipur</span>
                <p className="mt-4">
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia. It is a paradisematic country,
                  in which roasted parts of sentences fly into your mouth.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt-5">
            <div className="col-md-6 text-center ">
              <p>
                <ResumeDownloadBig />
              </p>
            </div>
          </div>
        </div>
      </Flex>
      {/* services section */}
      <section id="services-section">
        <div className="container">
          <div className="row justify-content-center py-5 mt-5">
            <div className="col-md-12 heading-section text-center">
              <h1 className="big big-2">Services</h1>
              <h2 className="mb-4">Services</h2>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 text-center d-flex">
              <a href=" " className="services-1">
                <span className="icon">
                  <i className="flaticon-analysis"></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5">React Js Development</h3>
                </div>
              </a>
            </div>
            <div className="col-md-4 text-center d-flex">
              <a href=" " className="services-1">
                <span className="icon">
                  <i className="flaticon-flasks"></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5">Node Js Development</h3>
                </div>
              </a>
            </div>
            <div className="col-md-4 text-center d-flex">
              <a href=" " className="services-1">
                <span className="icon">
                  <i className="flaticon-ideas"></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5">Full Stack Development</h3>
                </div>
              </a>
            </div>

            <div className="col-md-4 text-center d-flex">
              <a href=" " className="services-1">
                <span className="icon">
                  <i className="flaticon-analysis"></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5">Ecommerce Development</h3>
                </div>
              </a>
            </div>
            <div className="col-md-4 text-center d-flex">
              <a href=" " className="services-1">
                <span className="icon">
                  <i className="flaticon-flasks"></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5">Chat Application Development</h3>
                </div>
              </a>
            </div>
            <div className="col-md-4 text-center d-flex">
              <a href=" " className="services-1">
                <span className="icon">
                  <i className="flaticon-ideas"></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5">Payment gateway</h3>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Skills Section       */}
      <section id="skills-section">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-md-12 heading-section text-center">
              <h1 className="big big-2">Skills</h1>
              <h2 className="mb-4">My Skills</h2>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>React JS</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-1"
                    role="progressbar"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "90%",
                    }}
                  >
                    <span>90%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>Node JS</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-2"
                    role="progressbar"
                    aria-valuenow="85"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "70%",
                    }}
                  >
                    <span>70%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>HTML5</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-3"
                    role="progressbar"
                    aria-valuenow="95"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "80%",
                    }}
                  >
                    <span>80%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>CSS3</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-4"
                    role="progressbar"
                    aria-valuenow="90"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "80%",
                    }}
                  >
                    <span>80%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>Javascript</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-5"
                    role="progressbar"
                    aria-valuenow="70"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "80%",
                    }}
                  >
                    <span>80%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>Typescript</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-6"
                    role="progressbar"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "60%",
                    }}
                  >
                    <span>60%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>Chakra Ui</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-6"
                    role="progressbar"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "90%",
                    }}
                  >
                    <span>90%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>Bootstrap</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-6"
                    role="progressbar"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "80%",
                    }}
                  >
                    <span>80%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>MySql</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-6"
                    role="progressbar"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "60%",
                    }}
                  >
                    <span>60%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 animate-box">
              <div className="progress-wrap">
                <h3>Mongodb</h3>
                <div className="progress">
                  <div
                    className="progress-bar color-6"
                    role="progressbar"
                    aria-valuenow="80"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                      width: "70%",
                    }}
                  >
                    <span>70%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* our Projects Section */}

      <section className="ftco-section ftco-project" id="projects-section">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-md-12 heading-section text-center">
              <h1 className="big big-2">Projects</h1>
              <h2 className="mb-4">Our Projects</h2>
              <p>
                Check out our amazing portfolio of projects that showcase our
                creativity and expertise in web design and development.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Flex
                className="project img d-flex justify-content-center align-items-center"
                bg="url(images/weather.png)"
                backgroundSize="cover"
                backgroundPosition="center"
              >
                <div className="overlay"></div>
                <div className="text text-center p-4">
                  <h3>
                    <a href=" ">Weather App</a>
                  </h3>
                  <span>Web Design</span>
                </div>
              </Flex>
            </div>
            <div className="col-md-8">
              <Flex
                className="project img d-flex justify-content-center align-items-center"
                bg="url(images/pizza.png)"
                backgroundSize="cover"
                backgroundPosition="center"
              >
                <div className="overlay"></div>
                <div className="text text-center p-4">
                  <h3>
                    <a href=" ">Pizza Ordering Website</a>
                  </h3>
                  <span>Web Design</span>
                </div>
              </Flex>
            </div>

            <div className="col-md-8">
              <Flex
                className="project img d-flex justify-content-center align-items-center"
                bg="url(images/pricing.png)"
                backgroundSize="cover"
                backgroundPosition="center"
              >
                <div className="overlay"></div>
                <div className="text text-center p-4">
                  <h3>
                    <a href=" ">Pricing Page Redesign</a>
                  </h3>
                  <span>Web Design</span>
                </div>
              </Flex>

              <Flex
                className="project img d-flex justify-content-center align-items-center"
                bg="url(images/chat.png)"
                backgroundSize="cover"
                backgroundPosition="center"
              >
                <div className="overlay"></div>
                <div className="text text-center p-4">
                  <h3>
                    <a href=" ">Chat Application</a>
                  </h3>
                  <span>Web Design</span>
                </div>
              </Flex>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="col-md-12">
                  <Flex
                    className="project img d-flex justify-content-center align-items-center"
                    bg="url(images/movies.png)"
                    backgroundSize="cover"
                    backgroundPosition="center"
                  >
                    <div className="overlay"></div>
                    <div className="text text-center p-4">
                      <h3>
                        <a href=" ">Movie Recommendation App</a>
                      </h3>
                      <span>Web Design</span>
                    </div>
                  </Flex>
                </div>
                <div className="col-md-12">
                  <Flex
                    className="project img d-flex justify-content-center align-items-center"
                    bg="url(images/food.png)"
                    backgroundSize="cover"
                    backgroundPosition="center"
                  >
                    <div className="overlay"></div>
                    <div className="text text-center p-4">
                      <h3>
                        <a href=" ">Food Blog App</a>
                      </h3>
                      <span>Web Design</span>
                    </div>
                  </Flex>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* awards section                */}

      <Flex
        className="ftco-section ftco-hireme img margin-top"
        bg="url(images/bg_1.jpg)"
        backgroundSize="cover"
        backgroundPosition="center"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-7 text-center">
              <h2>
                I'm <span>Available</span> for freelancing
              </h2>
              <p>
                A small river named Duden flows by their place and supplies it
                with the necessary regelialia.
              </p>
              <p className="mb-0">
                <a href=" " className="btn btn-primary py-3 px-5">
                  Hire me
                </a>
              </p>
            </div>
          </div>
        </div>
      </Flex>

      {/* contact me section */}

      <section
        className="ftco-section contact-section ftco-no-pb"
        id="contact-section"
      >
        <div className="container">
          <div className="row justify-content-center mb-5 pb-3">
            <div className="col-md-7 heading-section text-center">
              <h1 className="big big-2">Contact</h1>
              <h2 className="mb-4">Contact Me</h2>
              <p>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia
              </p>
            </div>
          </div>

          <div className="row d-flex contact-info mb-5">
            <div className="col-md-6 col-lg-3 d-flex">
              <div className="align-self-stretch box p-4 text-center">
                <div className="icon d-flex align-items-center justify-content-center">
                  <span className="icon-map-signs"></span>
                </div>
                <h3 className="mb-4">Address</h3>
                <p>271 A kanak vihar Ajmer Road Jaipur, Rajasthan, India</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex">
              <div className="align-self-stretch box p-4 text-center">
                <div className="icon d-flex align-items-center justify-content-center">
                  <span className="icon-phone2"></span>
                </div>
                <h3 className="mb-4">Contact Number</h3>
                <p>
                  <a href="tel://1234567920">+91 7014888168</a>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex">
              <div className="align-self-stretch box p-4 text-center">
                <div className="icon d-flex align-items-center justify-content-center">
                  <span className="icon-paper-plane"></span>
                </div>
                <h3 className="mb-4">Email Address</h3>
                <p>
                  <a href="mailto:info@yoursite.com">
                    vikassingh.vs242@gmail.com
                  </a>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex">
              <div className="align-self-stretch box p-4 text-center">
                <div className="icon d-flex align-items-center justify-content-center">
                  <span className="icon-globe"></span>
                </div>
                <h3 className="mb-4">Website</h3>
                <p>
                  <a href=" ">Still Not</a>
                </p>
              </div>
            </div>
          </div>

          <div className="row no-gutters block-9">
            <div className="col-md-6 order-md-last d-flex">
              <form
                className="bg-light p-4 p-md-5 contact-form"
                onSubmit={handleSubmit}
              >
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                    name="name"
                    value={formValues.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    name="subject"
                    value={formValues.subject}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <textarea
                    id=""
                    cols="30"
                    rows="7"
                    className="form-control"
                    placeholder="Message"
                    name="message"
                    value={formValues.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="form-group">
                  <input
                    type="submit"
                    value="Send Message"
                    className="btn btn-primary py-3 px-5"
                  />
                </div>
              </form>
            </div>

            <div className="col-md-6 d-flex">
              <Flex
                className="img"
                bg="url(images/profile-1.png)"
                backgroundSize="cover"
                backgroundPosition="center"
              ></Flex>
            </div>
          </div>
        </div>
      </section>

      {/* Footer section                */}

      <footer className="ftco-footer ftco-section">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md">
              <div className="ftco-footer-widget mb-4">
                <h2 className="ftco-heading-2">About</h2>
                <p>
                  Far far away, behind the word mountains, far from the
                  countries Vokalia and Consonantia, there live the blind texts.
                </p>
                <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
                  <li className="">
                    <a href=" ">
                      <span className="icon-twitter"></span>
                    </a>
                  </li>
                  <li className="">
                    <a href=" ">
                      <span className="icon-facebook"></span>
                    </a>
                  </li>
                  <li className="">
                    <a href=" ">
                      <span className="icon-instagram"></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md">
              <div className="ftco-footer-widget mb-4 ml-md-4">
                <h2 className="ftco-heading-2">Links</h2>
                <ul className="list-unstyled">
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>Home
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>About
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>
                      Services
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>
                      Projects
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md">
              <div className="ftco-footer-widget mb-4">
                <h2 className="ftco-heading-2">Services</h2>
                <ul className="list-unstyled">
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>Full
                      Stack Develoment
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>Web
                      Development
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>
                      Ecommerce Development
                    </a>
                  </li>
                  <li>
                    <a href=" ">
                      <span className="icon-long-arrow-right mr-2"></span>Chat
                      Application Development
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md">
              <div className="ftco-footer-widget mb-4">
                <h2 className="ftco-heading-2">Have a Questions?</h2>
                <div className="block-23 mb-3">
                  <ul>
                    <li>
                      <span className="icon icon-map-marker"></span>
                      <span className="text">
                        271 A Kanak Vihar, Jaipur, Rajasthan, India
                      </span>
                    </li>
                    <li>
                      <a href=" ">
                        <span className="icon icon-phone"></span>
                        <span className="text">+91 7014888168</span>
                      </a>
                    </li>
                    <li>
                      <a href=" ">
                        <span className="icon icon-envelope"></span>
                        <span className="text">vikassingh.vs242@gmail.com</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <p>
              Copyright &copy;
              <script>document.write(new Date().getFullYear())</script> All
              rights reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HomePage;
